export const Constants = {
  PRODUCT_NAME: 'Counting Trucks',
  PRODUCT_URL: 'countingtrucks.com',
  RECURRENCE_TYPE_DAILY: 0,
  RECURRENCE_TYPE_WEEKLY: 1,
  RECURRENCE_TYPE_MONTHLY: 2,
  RECURRENCE_TYPE_YEARLY: 3,

  PAY_RATE_TYPE_BY_GROSS_PCNT: 0,
  PAY_RATE_TYPE_BY_MILE: 1,
  PAY_RATE_TYPE_PER_EXTRA_STOP: 2,
  PAY_RATE_TYPE_PER_WEEK: 3,

  LOAD_STATUS_ACTIVE: 0,
  LOAD_STATUS_DELIVERED: 1,
  LOAD_STATUS_PENDING_PAYMENT: 2,
  LOAD_STATUS_PAID: 3,
  LOAD_STATUS_CANCELLED: 4,

  LOAD_STOP_TYPE_BREAK: 0,
  LOAD_STOP_TYPE_FUEL: 1,

  STATEMENT_TYPE_DRIVER: 0,
  STATEMENT_TYPE_COMPANY: 1,

  LOAD_PAY_RATE_TYPE_DRIVER: 0,
  LOAD_PAY_RATE_TYPE_TRUCK: 1,

  ATTACHED_FILE_ENTITY_TYPE_LOAD: 'LOAD',
  ATTACHED_FILE_ENTITY_TYPE_UNKNOWN: 'UNKNOWN',
  ATTACHED_FILE_ENTITY_TYPE_MAINTENANCE: 'MAINTENANCE',

  STATEMENT_STATUS_NEW: 0,
  STATEMENT_STATUS_DONE: 1,

  STATEMENT_LINE_TYPE_LOAD: 0,
  STATEMENT_LINE_TYPE_CREDIT: 1,
  STATEMENT_LINE_TYPE_FUEL_CHARGE: 2,
  STATEMENT_LINE_TYPE_TOLL: 3,
  STATEMENT_LINE_TYPE_DEDUCTION: 4,
  STATEMENT_LINE_TYPE_WEEKLY_DRIVER_PAY: 5,
  STATEMENT_LINE_TYPE_DRIVER_STATEMENT: 6,

  TRUCK_DRIVER_FILE_TYPE_MVR: 'MVR',
  TRUCK_DRIVER_FILE_TYPE_CLEARINGHOUSE: 'Clearing House',
  TRUCK_DRIVER_FILE_TYPE_DL: 'CDL',
  TRUCK_DRIVER_FILE_TYPE_MEDICAL: 'Medical',
  TRUCK_DRIVER_FILE_TYPE_DOT: 'DOT',
  TRUCK_DRIVER_FILE_TYPE_REGISTRATION: 'Registration',
  TRUCK_DRIVER_FILE_TYPE_INSURANCE: 'Insurance',
  TRUCK_DRIVER_FILE_TYPE_WDT: 'WDT',

  ACCIDENT_STATUS_OPEN: 0,
  ACCIDENT_STATUS_CLOSED_PAID: 1,
  ACCIDENT_STATUS_CLOSED_NOT_PAID: 2,

  ACCIDENT_PROGRESS_STATUS_WORKING_ON_IT: 0,
  ACCIDENT_PROGRESS_STATUS_IN_PROCESS: 1,
  ACCIDENT_PROGRESS_STATUS_DONE: 2,

  MAINTENANCE_ITEM_QUALIFIER_TYPE_TIME: 0,
  MAINTENANCE_ITEM_QUALIFIER_TYPE_ODOMETER: 1,

  TIMEZONES: [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Anchorage',
  ],

  STATES: [
    "AL", "AK", "AR", "AZ", "CA", "CO", "CT", "DC", "DE",
    "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS", "KY",
    "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT",
    "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH",
    "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT",
    "VA", "VT", "WA", "WI", "WV", "WY",
  ]
};
